module.exports = __webpack_public_path__ + "img/liucheng.0f43600a.png";